import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { SituacaoComboService } from './situacao-combo.service';
import { ComboBase } from 'src/app/models/comboModel';

@Component({
    selector: 'max-situacao-combo',
    templateUrl: './situacao-combo.component.html'
})
export class SituacaoComboComponent implements OnInit {

    public lista!: ComboBase[];
    public selectedItem!: ComboBase;
    @Input() code: string = "";
    @Input() class!: string;
    @Input() idAtividadeEtapa!: number;
    @Input() selectedItemForm!: ComboBase;
    @Output() aoLimparSelecionado = new EventEmitter();
    @Output() itemSelecionado = new EventEmitter();

    constructor(private service: SituacaoComboService) { }

    ngOnInit(): void {
        this.code = "";


        if (this.selectedItemForm != null) {
            this.code = this.selectedItemForm.code ? this.selectedItemForm.code : '';
            this.selectedItem = this.selectedItemForm;
        }
        this.getLista();
    }

    ngOnChanges(): void {
        this.getLista();
    }

    getLista() {
        this.service.getLista(this.idAtividadeEtapa)
            .subscribe(
                (res) => {
                    if (res) {
                        this.lista = res;
                    }
                },
                err => {
                    console.log(`EtapaList ` + err);
                }
            );
    }

    onClear(event: any) {
        this.aoLimparSelecionado.emit(event);
    }
    onChange(event: any) {
        this.itemSelecionado.emit(event.value);
    }
}